module.exports = __webpack_public_path__ + "static/armorer-70b8faf1fbcaa47abeb6ca8457b564d5.png";